module.exports = __webpack_public_path__ + "img/shop-name-board.64bfa89a.png";